module.exports = __webpack_public_path__ + "img/cart.6b913b3.svg";